import PropTypes from 'prop-types';

const withTheme = Component => {
  if (!Component.contextTypes) {
    Component.contextTypes = {};
  }

  Component.contextTypes.theme = PropTypes.object;

  return Component;
};

export default withTheme;



// WEBPACK FOOTER //
// ./src/decorators/with-theme.js